export default class AdminConfig{
    constructor(config){
        this.node = config.node;
    }
}